import { Component, OnInit, ViewChild, Input } from '@angular/core';
import { common } from 'src/app/app.common';
import { Router, ActivatedRoute } from '@angular/router';
import { DataTableDirective } from 'angular-datatables';
import { Subject } from 'rxjs';
import { NgbModal, ModalDismissReasons } from '@ng-bootstrap/ng-bootstrap';
import { AbstractControl, FormControl, FormGroup } from '@angular/forms';
import { DashBoardService } from 'src/app/utils/services/dash-board.service';
import { AllService } from 'src/app/Utils/services/all.service';
import { HocTapRenLuyenService } from 'src/app/Utils/services/hoc-tap-ren-luyen.service';
import { HoSoHSSVService } from 'src/app/Utils/services/ho-so-hssv.service';
import { NgxSpinnerModule, NgxSpinnerService } from "ngx-spinner";
import * as CanvasJS from './canvasjs.min';
import * as Canvas from './canvasjs.min.js';
@Component({
  selector: 'app-dashboard',
  templateUrl: './dashboard.component.html',
  styleUrls: ['./dashboard.component.scss'],
})
export class DashboardComponent implements OnInit {

  Token: any
  constructor(
    private modalService: NgbModal,
    private DashBoardService: DashBoardService,
    public router: Router,
    private AllService: AllService,
    private HocTapRenLuyenService: HocTapRenLuyenService,
    private HoSoHSSVService: HoSoHSSVService,
    private spinner: NgxSpinnerService

  ) { }
  public com: common
  Hoc_ky: number = 1
  Nam_hoc: string = "2020-2021"
  He: number
  dsID_lop: string
  SV_dang_hoc: any = 0
  SV_thoi_hoc: any = 0
  closeResult: string;
  dataHe: any = []
  dataKhoa: any = []
  dataKhoaHoc2: any = []
  dataKhoaHoc: any = []
  dataChuyenNganh: any = []
  dataChuyenNganh2: any = []
  dataLop: any = []
  dataLop2: any = []
  dataHe2: any = []
  dataHe3: any = []
  dataKhoa2: any = []
  dataKhoa3: any = []
  dataKhoaHoc3: any = []
  dataKhoaHoc4: any = []
  dataChuyenNganh3: any = []
  dataChuyenNganh4: any = []
  dataChuyenNganh5: any = []
  dataChuyenNganh6: any = []
  dataKhoaHoc5: any = []
  dataKhoaHoc6: any = []
  dataLop3: any = []
  dataLop4: any = []
  dataLop5: any = []
  dataLop6: any = []
  Nam_hoc_arr: any = []
  listID_lop: any
  listID_lop2: any
  listID_lop3: any
  dataHeader: any = []
  dataTable: any = []
  dataChart: any = []
  chart: any
  filter = new FormGroup({
    Hoc_ky: new FormControl(0),
    Nam_hoc: new FormControl((new Date().getFullYear() - 1) + '-' + new Date().getFullYear()),
    ID_he: new FormControl(null),
    ID_khoa: new FormControl(""),
    ID_lop: new FormControl(""),
    ID_chuyen_nganh: new FormControl(""),
    Khoa_hoc: new FormControl(""),
  });
  tableFilter = new FormGroup({
    Hoc_ky: new FormControl(1),
    Nam_hoc: new FormControl((new Date().getFullYear() - 1) + '-' + new Date().getFullYear()),
    ID_he: new FormControl(null),
    ID_khoa: new FormControl(""),
    ID_lop: new FormControl(""),
    ID_chuyen_nganh: new FormControl(""),
    Khoa_hoc: new FormControl(""),
  });
  chartFilter = new FormGroup({
    Hoc_ky: new FormControl(1),
    Nam_hoc: new FormControl((new Date().getFullYear() - 1) + '-' + new Date().getFullYear()),
    ID_he: new FormControl(null),
    ID_khoa: new FormControl(""),
    ID_lop: new FormControl(""),
    ID_chuyen_nganh: new FormControl(""),
    Khoa_hoc: new FormControl(""),
  });
  ngOnInit() {
    var yearNow = new Date().getFullYear() ;
    for (var i = 0; i < 10; i++) {
      let Nam_hoc_string = yearNow + '-' + (yearNow + 1);
      let object = {
        value: Nam_hoc_string,
        name: Nam_hoc_string,
      };
      this.Nam_hoc_arr.push(object);
      yearNow--;
    }
    this.com = new common(this.router)
    this.com.CheckLogin();
    var a = this.com.getUserinfo()
    this.Token = a.Token

    this.getList()

  }
  getList() {
    this.spinner.show();
    let IDhe;
    let IDKhoahoc;
    this.AllService.getHe(this.Token).subscribe((z) => {
      this.dataHe = z
      IDhe = z[0].ID_he
      this.filter.patchValue({ ID_he: z[0].ID_he });
      this.AllService.getKhoa(this.Token).subscribe((z) => {
        this.dataKhoa = z
        this.AllService.getKhoaHoc(this.Token).subscribe((z) => {
          this.dataKhoaHoc = z.Data
          this.dataKhoaHoc2 = this.dataKhoaHoc.filter(i => i.ID_he == IDhe);
          this.dataKhoaHoc2 = this.dataKhoaHoc2.filter((item, i, arr) => arr.findIndex((t) => t.Khoa_hoc === item.Khoa_hoc) === i);
          this.AllService.getLop(this.Token).subscribe((z) => {
            this.dataChuyenNganh = z
            this.dataChuyenNganh2 = this.dataChuyenNganh
            this.dataChuyenNganh2 = this.dataChuyenNganh2.filter(i => i.ID_he == IDhe);
            this.dataChuyenNganh2 = this.dataChuyenNganh2.filter((item, i, arr) => arr.findIndex((t) => t.ID_chuyen_nganh === item.ID_chuyen_nganh) === i);
            this.dataLop = z
            this.dataLop2 = this.dataLop.filter(i => i.ID_he == IDhe);
            this.listID_lop = ""
            if (this.filter.value.ID_lop == "") {
              this.dataLop.forEach(element => {
                this.listID_lop += element.ID_lop + ","
              });
            } else {
              this.listID_lop = this.filter.value.ID_lop
            }
            this.listID_lop = this.listID_lop + "0"
            let req = {
              "Hoc_ky": this.filter.value.Hoc_ky,
              "Nam_hoc": this.filter.value.Nam_hoc,
              "objID_lop": {
                "ID_lop": 0,
                "Ten_lop": "",
                "ID_he": this.filter.value.ID_he,
                "ID_khoa": 0,
                "ID_chuyen_nganh": 0,
                "Khoa_hoc": 0,
                "Ten_he": "",
                "Ten_khoa": "",
                "Chuyen_nganh": "",
                "Ten_nganh": "",
                "Nien_khoa": "2017-2021",
                "ID_dt": 0,
                "So_sv": 0,
                "Ra_truong": false,
                "ID_nganh": 0,
                "dsID_lop": this.listID_lop,
                "dsID_dt": ""
              },
              "dsID_lop": this.listID_lop
            }
            this.DashBoardService.getCount(req, this.Token).subscribe((z) => {
              this.SV_dang_hoc = z.SV_dang_hoc
              this.SV_thoi_hoc = z.SV_thoi_hoc
              this.getTable()
              this.spinner.hide();
            });
          });
        });
      });
    });
  }
  open(content, sizm, Loai, Data) {
    this.modalService
      .open(content, { ariaLabelledBy: 'modal-basic-title', size: sizm })
      .result.then(
        (result) => {
          this.closeResult = `Closed with: ${result}`;
        },
        (reason) => {
          this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
        }
      );
  }
  onSubmit() {
    this.listID_lop = ""
    if (this.filter.value.ID_lop == "") {
      this.dataLop.forEach(element => {
        this.listID_lop += element.ID_lop + ","
      });
    } else {
      this.listID_lop = this.filter.value.ID_lop
    }
    this.listID_lop = this.listID_lop + "0"
    let req = {
      "Hoc_ky": this.filter.value.Hoc_ky,
      "Nam_hoc": this.filter.value.Nam_hoc,
      "objID_lop": {
        "ID_lop": 0,
        "Ten_lop": "",
        "ID_he": this.filter.value.ID_he,
        "ID_khoa": 0,
        "ID_chuyen_nganh": 0,
        "Khoa_hoc": 0,
        "Ten_he": "",
        "Ten_khoa": "",
        "Chuyen_nganh": "",
        "Ten_nganh": "",
        "Nien_khoa": "2017-2021",
        "ID_dt": 0,
        "So_sv": 0,
        "Ra_truong": false,
        "ID_nganh": 0,
        "dsID_lop": this.listID_lop,
        "dsID_dt": ""
      },
      "dsID_lop": this.listID_lop
    }
    this.DashBoardService.getCount(req, this.Token).subscribe((z) => {
      this.SV_dang_hoc = z.SV_dang_hoc
      this.SV_thoi_hoc = z.SV_thoi_hoc
    });
    this.modalService.dismissAll('AddModal');

  }
  onSubmit2() {
    this.dataTable = []
    this.listID_lop2 = ""
    if (this.tableFilter.value.ID_lop == "") {
      this.dataLop3.forEach(element => {
        this.listID_lop2 += element.ID_lop + ","
      });
    } else {
      this.listID_lop2 = this.tableFilter.value.ID_lop
    }
    this.listID_lop2 = this.listID_lop2 + "0"
    let req = {
      "kyThongke": 0,
      "Hoc_ky": this.tableFilter.value.Hoc_ky,
      "Nam_hoc": this.tableFilter.value.Nam_hoc,
      "objID_lop": {
        "ID_lop": this.tableFilter.value.ID_lop == "" ? 0 : this.tableFilter.value.ID_lop,
        "Ten_lop": "",
        "ID_he": this.tableFilter.value.ID_he,
        "ID_khoa": this.tableFilter.value.ID_khoa == "" ? 0 : this.tableFilter.value.ID_khoa,
        "ID_chuyen_nganh": this.tableFilter.value.ID_chuyen_nganh == "" ? 0 : this.tableFilter.value.ID_chuyen_nganh,
        "Khoa_hoc": this.tableFilter.value.Khoa_hoc == "" ? 0 : this.tableFilter.value.Khoa_hoc,
        "Ten_he": "",
        "Ten_khoa": "",
        "Chuyen_nganh": "",
        "Ten_nganh": "",
        "Nien_khoa": "2017-2021",
        "ID_dt": 0,
        "So_sv": 0,
        "Ra_truong": false,
        "ID_nganh": 15,
        "dsID_lop": this.listID_lop2,
        "dsID_dt": ""
      },
      "Nhom_thong_ke": 5,
      "ID_he": this.tableFilter.value.ID_he
    }
    this.HocTapRenLuyenService.getDataDashboard(req, this.Token).subscribe((z) => {
      this.dataHeader = z.Header
      this.dataTable = z.Data
    });
    this.modalService.dismissAll('AddModal');

  }
  private getDismissReason(reason: any): string {
    if (reason === ModalDismissReasons.ESC) {
      return 'by pressing ESC';
    } else if (reason === ModalDismissReasons.BACKDROP_CLICK) {
      return 'by clicking on a backdrop';
    } else {
      return `with: ${reason}`;
    }
  }
  getTable() {
    let IDhe;
    let IDKhoahoc;
    this.AllService.getHe(this.Token).subscribe((z) => {
      this.dataHe2 = z
      IDhe = z[0].ID_he
      this.tableFilter.patchValue({ ID_he: z[0].ID_he });
      this.AllService.getKhoa(this.Token).subscribe((z) => {
        this.dataKhoa2 = z
        this.AllService.getKhoaHoc(this.Token).subscribe((z) => {
          this.dataKhoaHoc3 = z.Data
          this.dataKhoaHoc4 = this.dataKhoaHoc3.filter(i => i.ID_he == IDhe);
          this.dataKhoaHoc4 = this.dataKhoaHoc4.filter((item, i, arr) => arr.findIndex((t) => t.Khoa_hoc === item.Khoa_hoc) === i);

          this.AllService.getLop(this.Token).subscribe((z) => {
            this.dataChuyenNganh3 = z
            this.dataChuyenNganh4 = this.dataChuyenNganh3
            this.dataChuyenNganh4 = this.dataChuyenNganh4.filter(i => i.ID_he == IDhe);
            this.dataChuyenNganh4 = this.dataChuyenNganh4.filter((item, i, arr) => arr.findIndex((t) => t.ID_chuyen_nganh === item.ID_chuyen_nganh) === i);
            this.dataLop3 = z
            this.dataLop4 = this.dataLop3.filter(i => i.ID_he == IDhe);
            this.listID_lop2 = ""
            if (this.tableFilter.value.ID_lop == "") {
              this.dataLop3.forEach(element => {
                this.listID_lop2 += element.ID_lop + ","
              });
            } else {
              this.listID_lop2 = this.tableFilter.value.ID_lop
            }
            this.listID_lop2 = this.listID_lop2 + "0"
            let req = {
              "kyThongke": 0,
              "Hoc_ky": this.tableFilter.value.Hoc_ky,
              "Nam_hoc": this.tableFilter.value.Nam_hoc,
              "objID_lop": {
                "ID_lop": this.tableFilter.value.ID_lop == "" ? 0 : this.tableFilter.value.ID_lop,
                "Ten_lop": "",
                "ID_he": this.tableFilter.value.ID_he,
                "ID_khoa": this.tableFilter.value.ID_khoa == "" ? 0 : this.tableFilter.value.ID_khoa,
                "ID_chuyen_nganh": this.tableFilter.value.ID_chuyen_nganh == "" ? 0 : this.tableFilter.value.ID_chuyen_nganh,
                "Khoa_hoc": this.tableFilter.value.Khoa_hoc == "" ? 0 : this.tableFilter.value.Khoa_hoc,
                "Ten_he": "",
                "Ten_khoa": "",
                "Chuyen_nganh": "",
                "Ten_nganh": "",
                "Nien_khoa": "2017-2021",
                "ID_dt": 0,
                "So_sv": 0,
                "Ra_truong": false,
                "ID_nganh": 15,
                "dsID_lop": this.listID_lop2,
                "dsID_dt": ""
              },
              "Nhom_thong_ke": 5,
              "ID_he": this.tableFilter.value.ID_he
            }
            this.HocTapRenLuyenService.getDataDashboard(req, this.Token).subscribe((z) => {
              this.dataHeader = z.Header
              this.dataTable = z.Data
              this.getChart()
            });
          });
        });
      });
    });

  }
  getChart() {
    let IDhe;
    let IDKhoahoc;
    this.AllService.getHe(this.Token).subscribe((z) => {
      this.dataHe3 = z
      IDhe = z[0].ID_he
      this.chartFilter.patchValue({ ID_he: z[0].ID_he });
      this.AllService.getKhoa(this.Token).subscribe((z) => {
        this.dataKhoa3 = z
        this.AllService.getKhoaHoc(this.Token).subscribe((z) => {
          this.dataKhoaHoc5 = z.Data
          this.dataKhoaHoc6 = this.dataKhoaHoc5.filter(i => i.ID_he == IDhe);
          this.dataKhoaHoc6 = this.dataKhoaHoc6.filter((item, i, arr) => arr.findIndex((t) => t.Khoa_hoc === item.Khoa_hoc) === i);

          this.AllService.getLop(this.Token).subscribe((z) => {
            this.dataChuyenNganh5 = z
            this.dataChuyenNganh6 = this.dataChuyenNganh5
            this.dataChuyenNganh6 = this.dataChuyenNganh6.filter(i => i.ID_he == IDhe);
            this.dataChuyenNganh6 = this.dataChuyenNganh6.filter((item, i, arr) => arr.findIndex((t) => t.ID_chuyen_nganh === item.ID_chuyen_nganh) === i);
            this.dataLop5 = z
            this.dataLop6 = this.dataLop5.filter(i => i.ID_he == IDhe);
            this.listID_lop3 = ""
            if (this.chartFilter.value.ID_lop == "") {
              this.dataLop5.forEach(element => {
                this.listID_lop3 += element.ID_lop + ","
              });
            } else {
              this.listID_lop3 = this.tableFilter.value.ID_lop
            }
            this.listID_lop3 = this.listID_lop3 + "0"
            let req = {
              "kyThongke": 0,
              "Hoc_ky": this.chartFilter.value.Hoc_ky,
              "Nam_hoc": this.chartFilter.value.Nam_hoc,
              "objID_lop": {
                "ID_lop": this.chartFilter.value.ID_lop == "" ? 0 : this.chartFilter.value.ID_lop,
                "Ten_lop": "",
                "ID_he": this.chartFilter.value.ID_he,
                "ID_khoa": this.chartFilter.value.ID_khoa == "" ? 0 : this.chartFilter.value.ID_khoa,
                "ID_chuyen_nganh": this.chartFilter.value.ID_chuyen_nganh == "" ? 0 : this.chartFilter.value.ID_chuyen_nganh,
                "Khoa_hoc": this.chartFilter.value.Khoa_hoc == "" ? 0 : this.chartFilter.value.Khoa_hoc,
                "Ten_he": "",
                "Ten_khoa": "",
                "Chuyen_nganh": "",
                "Ten_nganh": "",
                "Nien_khoa": "2017-2021",
                "ID_dt": 0,
                "So_sv": 0,
                "Ra_truong": false,
                "ID_nganh": 15,
                "dsID_lop": this.listID_lop3,
                "dsID_dt": ""
              },
              "Nhom_thong_ke": 5,
              "ID_he": this.chartFilter.value.ID_he
            }
            this.HoSoHSSVService.getDataChart(req, this.Token).subscribe((z) => {
              this.dataChart = []
              let listData = {}
              z.Data.forEach(element => {
                listData = {
                  type: "column",
                  name: element.Name,
                  legendText: element.Name,
                  showInLegend: true,
                  dataPoints: element.Value
                }
                this.dataChart.push(listData)
              });
              this.chart = new CanvasJS.Chart("chartContainer", {
                animationEnabled: true,
                exportEnabled: true,
                axisY: {
                  title: "Tỷ lệ % sinh viên",
                  titleFontColor: "#4F81BC",
                  lineColor: "#4F81BC",
                  labelFontColor: "#4F81BC",
                  tickColor: "#4F81BC"
                },
                toolTip: {
                  shared: true
                },
                legend: {
                  cursor: "pointer",
                  reversed: true,
                  verticalAlign: "top",
                },
                data: this.dataChart
              });
              this.chart.render();
            });
          });
        });
      });
    });

  }
  onSubmit3() {
    this.listID_lop3 = ""
    if (this.tableFilter.value.ID_lop == "") {
      this.dataLop5.forEach(element => {
        this.listID_lop3 += element.ID_lop + ","
      });
    } else {
      this.listID_lop3 = this.tableFilter.value.ID_lop
    }
    this.listID_lop3 = this.listID_lop3 + "0"
    let req = {
      "kyThongke": 0,
      "Hoc_ky": this.chartFilter.value.Hoc_ky,
      "Nam_hoc": this.chartFilter.value.Nam_hoc,
      "objID_lop": {
        "ID_lop": this.chartFilter.value.ID_lop == "" ? 0 : this.chartFilter.value.ID_lop,
        "Ten_lop": "",
        "ID_he": this.chartFilter.value.ID_he,
        "ID_khoa": this.chartFilter.value.ID_khoa == "" ? 0 : this.chartFilter.value.ID_khoa,
        "ID_chuyen_nganh": this.chartFilter.value.ID_chuyen_nganh == "" ? 0 : this.chartFilter.value.ID_chuyen_nganh,
        "Khoa_hoc": this.chartFilter.value.Khoa_hoc == "" ? 0 : this.chartFilter.value.Khoa_hoc,
        "Ten_he": "",
        "Ten_khoa": "",
        "Chuyen_nganh": "",
        "Ten_nganh": "",
        "Nien_khoa": "2017-2021",
        "ID_dt": 0,
        "So_sv": 0,
        "Ra_truong": false,
        "ID_nganh": 15,
        "dsID_lop": this.listID_lop3,
        "dsID_dt": ""
      },
      "Nhom_thong_ke": 5,
      "ID_he": this.chartFilter.value.ID_he
    }
    this.HoSoHSSVService.getDataChart(req, this.Token).subscribe((z) => {
      let listData = {}
      this.dataChart =[]

      z.Data.forEach(element => {
        listData = {
          type: "column",
          name: element.Name,
          legendText: element.Name,
          showInLegend: true,
          dataPoints: element.Value
        }
        this.dataChart.push(listData)
      });
      this.chart = new CanvasJS.Chart("chartContainer", {
        animationEnabled: true,
        exportEnabled: true,
        axisY: {
          title: "Tỷ lệ % sinh viên",
          titleFontColor: "#4F81BC",
          lineColor: "#4F81BC",
          labelFontColor: "#4F81BC",
          tickColor: "#4F81BC"
        },
        toolTip: {
          shared: true
        },
        legend: {
          cursor: "pointer",
          reversed: true,
          verticalAlign: "top",
        },
        data: this.dataChart
      });
      this.chart.render();
    });
    this.modalService.dismissAll('AddModal');

  }
  changeHe() {
    this.dataKhoaHoc2 = this.dataKhoaHoc.filter(i => i.ID_he == this.filter.value.ID_he);
    this.dataKhoaHoc2 = this.dataKhoaHoc2.filter((item, i, arr) => arr.findIndex((t) => t.Khoa_hoc === item.Khoa_hoc) === i);
    this.dataChuyenNganh2 = this.dataChuyenNganh.filter(i => i.ID_he == this.filter.value.ID_he);
    this.dataChuyenNganh2 = this.dataChuyenNganh2.filter((item, i, arr) => arr.findIndex((t) => t.ID_chuyen_nganh === item.ID_chuyen_nganh) === i);
    this.dataLop2 = this.dataLop.filter(i => i.ID_he == this.filter.value.ID_he);
  }
  changeHe2() {
    this.dataKhoaHoc4 = this.dataKhoaHoc3.filter(i => i.ID_he == this.tableFilter.value.ID_he);
    this.dataKhoaHoc4 = this.dataKhoaHoc4.filter((item, i, arr) => arr.findIndex((t) => t.Khoa_hoc === item.Khoa_hoc) === i);
    this.dataChuyenNganh4 = this.dataChuyenNganh3.filter(i => i.ID_he == this.tableFilter.value.ID_he);
    this.dataChuyenNganh4 = this.dataChuyenNganh4.filter((item, i, arr) => arr.findIndex((t) => t.ID_chuyen_nganh === item.ID_chuyen_nganh) === i);
    this.dataLop4 = this.dataLop3.filter(i => i.ID_he == this.tableFilter.value.ID_he);
  }
  changeHe3() {
    this.dataKhoaHoc6 = this.dataKhoaHoc5.filter(i => i.ID_he == this.chartFilter.value.ID_he);
    this.dataKhoaHoc6 = this.dataKhoaHoc6.filter((item, i, arr) => arr.findIndex((t) => t.Khoa_hoc === item.Khoa_hoc) === i);
    this.dataChuyenNganh6 = this.dataChuyenNganh5.filter(i => i.ID_he == this.chartFilter.value.ID_he);
    this.dataChuyenNganh6 = this.dataChuyenNganh6.filter((item, i, arr) => arr.findIndex((t) => t.ID_chuyen_nganh === item.ID_chuyen_nganh) === i);
    this.dataLop6 = this.dataLop5.filter(i => i.ID_he == this.chartFilter.value.ID_he);
  }

}
